module.exports = __webpack_public_path__ + "img/fr.dae4d750.svg";